export default "__VITE_ASSET__Ba53AdFv__"